import { useSelector } from "react-redux";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  RouterProvider
} from "react-router-dom";
import { KoLayout } from "./layouts";

import ChangePass from "pages/account/changePassword";
import ForgotPass from "pages/account/forgotPassword";
import Login from "pages/account/login";
import Requested from "pages/account/requested";
import VerifyAccount from "pages/account/verify";

import AdminConsole from "pages/admin";
import Settings from "pages/admin/settings";
import MasterData from "pages/admin/masterData";
import ApiClient from "pages/apiClient";
import ApiRequest from "pages/apiClient/request";
import Browse from "pages/browse";
// import FilesPreview from "pages/browse/files";
import InvoicePreview from "pages/browse/invoice";
import TaskPreview from "pages/browse/tasks";
// import Calendar from "pages/calendar";
import Clients from "pages/customers/customersList";
import Deployment from "pages/deployment";
import Services from "pages/deployment/services";
import Invoices from "pages/finance";
import InvoiceDashboard from "pages/finance/dashboard";
import InvoicePage from "pages/finance/invoice";
import InvoiceTemplate from "pages/finance/templete";
import Organization from "pages/organization";
import Departments from "pages/organization/departments";
import Designations from "pages/organization/designations";
import Employees from "pages/organization/employees";
import Groups from "pages/organization/groups";
import Payslips from "pages/home/payslips";
import Profile from "pages/profile";
import HomeDashboard from "pages/feed";
import ExpensesTravel from "pages/profile/expensesTravel";
import ManageTax from "pages/profile/managetax";
import PaySlips from "pages/profile/payslips";
import Performance from "pages/profile/performance";
import TaskPlannerDetails from "pages/workspace/process/development";
import Dashboard from "pages/workspace/process/development/dashboard";
import Sprint from "pages/workspace/process/development/sprint";
import Tasks from "pages/workspace/process/development/task";
import Workspace from "pages/workspace";
import Scrum from "pages/workspace/process/development/scrum";

//orders
import OrdersPage    from "pages/workspace/process/orders";
import OrdersDashbord from "pages/workspace/process/orders/dashboard";
import OrderOrder     from "pages/workspace/process/orders/order";
import OrderCustomers from "pages/workspace/process/orders/customers";
import OrderInvoices from "pages/workspace/process/orders/invoices";
import OrderProducts from "pages/workspace/process/orders/products";
import OrderSettings from "pages/workspace/process/orders/settings";
import OrderShipping from "pages/workspace/process/orders/shipping";
import OrderProductList from "pages/workspace/process/orders/products/productList";
import OrderProductCategory from "pages/workspace/process/orders/products/productCategory";
import Category from "pages/workspace/process/orders/products/productCategory/category";


import Chats from "pages/chat";
import HomePage from "pages/home";
import ReleasePlan from "pages/workspace/process/development/releasePlan";

// import BuildRequest from "pages/taskPlanner/buildRequest";
import { KoButton, KoTitle } from "packages";
import KoIcon from "@kwapio/icons";
import CreateAccount from "pages/account/createAccount";
import Announcements from "pages/admin/announcements";
import HoliDayCalendar from "pages/admin/holiday";
import Ownership from "pages/admin/ownership";
import Integration from "pages/admin/appintgarions";
import Payroll from "pages/admin/payroll";
import PolicyDocuments from "pages/admin/policyDocuments";
import Polls from "pages/polls";
import Collections from "pages/apiClient/collections";
import ApiClientDashboard from "pages/apiClient/dashboard";
import Environments from "pages/apiClient/environment";
import CalendarPreview from "pages/browse/calendar";
import CalendarDashboard from "pages/engagements/dashboard";
import Events from "pages/engagements/events";
import Meetings from "pages/engagements/meetngs";
import InvoiceList from "pages/finance/invoice/list";
import PreviewInvoice from "pages/finance/invoice/previewInvoice";
import Roles from "pages/organization/roles";
import BackLogs from "pages/workspace/process/development/backlog";
import SuportSystem from "pages/support/tickets";
import Epic from "pages/workspace/process/development/epic";
// import Module from "pages/taskPlanner/module";
// import Component from "pages/taskPlanner/component";
import AccountDashboard from "pages/account/dashboard";
import KioAI from "pages/kioAI";
import GenrateInvoice from "pages/finance/genrateInvoice";
import TestCases from "pages/testcases";
import MoreComponents from "pages/workspace/process/development/more";
import Drive from "pages/drive";
import DocumentPerivew from "pages/browse/files";
import FileDrive from "pages/drive/mydrive";
import SharedFileDrive from "pages/drive/sharedwithMe";
import StarredFileDrive from "pages/drive/starred";
import BinFileDrive from "pages/drive/bin";
import ProjectMgmtDashboard from "pages/workspace/process/development/dashboard";
import WorkspaceDrive from "shared/components/workspaceDrive";
import RecentFileDrive from "pages/drive/recent";
import IconGallery from "pages/story";
import TaskCalendar from "pages/workspace/process/development/taskcalendar";
import EngagementsDetails from "pages/engagements/main";
import EggContacts from "pages/engagements/contacts";
// import Track from "pages/finance/track";
import FormCurd from "pages/workspace/forms/curd";
import IssuesListing from "pages/workspace/process/development/sprint/Issue/index";
import PublicForm from "pages/browse/form";
import CustomerDetails from "pages/customers";
import CustomerDashboard from "pages/customers/dashboard";
import CustomerWorkflowType from "pages/customers/workflow";
import CustomerActivityType from "pages/customers/types";
import MessageTemplates from "pages/customers/templates";
import CustomerAnnouncements from "pages/customers/announcements";
import ManageRatings from "pages/customers/ratings";
import CustomerLeads from "pages/customers/leads";
import CustomerSettings from "pages/customers/ratings/ratingForms";
import CustomerPayments from "pages/customers/payments";
import PublicCustomer from "pages/browse/customer";
import B2Customers from "pages/browse/b2c";
import FinanceModule from "pages/workspace/process/finance";
import SupportModule from "pages/workspace/process/support";
import MarketingMoudule from "pages/workspace/process/marketing";
import HrModule from "pages/workspace/process/hr";
import HepldeskModule from "pages/workspace/process/helpdesk";
import SalesModule from "pages/workspace/process/sales";
import AssetsModule from "pages/workspace/process/assets";
import InboxComponent from "pages/home/inbox";
import MySchedules from "pages/home/schedules";
import MyTask from "pages/home/mytask";
import MyTimesheet from "pages/home/mytimesheets";
import MyLeaves from "pages/home/myleaves";
import MyTeams from "pages/home/myteams";
import MyExpenses from "pages/home/myexpenses";
import TimeLine from "pages/home/timeline";
import DevTimeLine from "pages/workspace/process/development/timeline";
import Evently from "pages/home/evently";
import PayRolls from "pages/paybooks/payroll";
import Attendance from "pages/paybooks/payroll/attendance";
import PayRun from "pages/paybooks/payroll/payrun";
import PayrollHistory from "pages/paybooks/payroll/payrollHistory";
import Form16 from "pages/paybooks/payroll/form16";
import Loans from "pages/paybooks/payroll/loans";
import ProofOfInvestments from "pages/paybooks/payroll/proofOfInvestments";
import Reimbursements from "pages/paybooks/payroll/reimbursements";
import SalaryRevision from "pages/paybooks/payroll/salaryRevision";
import PayrollDashboard from "pages/paybooks/payroll/dashboard";
import Track from "pages/finance/track";
import Vendors from "pages/paybooks/purchases/vendors";
import Expenses from "pages/paybooks/purchases/expenses";
import Purchases from "pages/paybooks/purchases";
import RecurringExpenses from "pages/paybooks/purchases/recurringExpenses";
import PurchingOrder from "pages/paybooks/purchases/purchaseOrders";
import Bills from "pages/paybooks/purchases/bills";
import RecurringBills from "pages/paybooks/purchases/recurringBills";

import Sales from "pages/paybooks/sales";
import SalesOrder from "pages/paybooks/sales/salesOrder";
import Estimates from "pages/paybooks/sales/estimates";
import RetainerInvoices from "pages/paybooks/sales/retainerInvoices";
import PaymentsReceived from "pages/paybooks/sales/paymentReceived";
import PaybookInvoices from "pages/paybooks/sales/invoices";
import RecurringInvoices from "pages/paybooks/sales/recurringInvoices";
import RestChangePass from "pages/account/resetPassword";
import PublicFeed from "pages/feed/public/feed";
import Component from "pages/workspace/process/development/component";
import Module from "pages/workspace/process/development/module";
import Retrospectives from "pages/workspace/process/development/retrospectives";
import { PullRequests, QATesting, ReleaseList, ReleaseDashboard, ReleaseGate, ReleaseNotes, UATSignoff } from "pages/workspace/process/development/release";
import { MonitoringOverview, ReleaseMonitoring, LiveMetrics, LogExplorer, Alerts, Incidents, ServiceHealth } from "pages/workspace/process/development/monitoring";
import { Services as ApiServices, Endpoints as ApiEndpoints, Explorer as ApiExplorer, Collections as ApiCollections, Environments as ApiEnvironments, ContractDiff, ReleaseTests, AuditLogs } from "pages/workspace/process/development/apiplatform";
import Environment from "pages/workspace/process/development/environment";


function RootRouter() {
  const auth = useSelector((state) => state?.auth);

  const ProtectedRoute = ({ element }) => {
    const auth = useSelector((state) => state?.auth);
    return auth?.authenticated ? element : <Navigate to="/account/login" />;
  };

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        {auth?.authenticated ? (
          <Route index element={<Navigate to="/home/feed" />} />
        ) : (
          <Route index path="/" element={<Login />} />
        )}
        <Route
          index
          path="/support/tickets/:accountId/:workspaceId"
          element={<SuportSystem />}
        />
        <Route index path="/account/forgotpassword" element={<ForgotPass />} />
        <Route index path="/account/verify" element={<VerifyAccount />} />
        <Route
          index
          path="/account/changepassword/:mailId"
          element={<ChangePass />}
        />
        <Route index path="/account/reset-password/:token" element={<RestChangePass />} />
        <Route index path="/account/requested" element={<Requested />} />
        <Route path="/account/login" element={<Login />} />
        <Route
          index
          path="/account/create-account"
          element={<CreateAccount />}
        />
        <Route index path="/account/icons" element={<IconGallery />} />
        <Route path="/" element={<ProtectedRoute element={<KoLayout />} />}>
          <Route path="/workspaces" element={<Workspace />} />
          <Route path="/kio-ai" element={<KioAI />} />
          

          <Route path="/home" element={<HomePage />}>
            <Route path="inbox" element={<InboxComponent />} />
            <Route path="feed" element={<HomeDashboard />} />
            <Route path="schedule" element={<MySchedules />} />
            <Route path="evently" element={<Evently />} />
            <Route path="mytask" element={<MyTask />} />
            <Route path="mytimesheets" element={<MyTimesheet />} />
            <Route path="leave" element={<MyLeaves />} />
            <Route path="myteams" element={<MyTeams />} />
            <Route path="timeline" element={<TimeLine />} />
            <Route path="myexpenses" element={<MyExpenses />} />
            <Route path="polls" element={<Polls title="Polls" />} />
            <Route path="performance" element={<Performance />} />
            <Route path="expenses" element={<ExpensesTravel />} />
            <Route path="payslips" element={<PaySlips />} />
            <Route path="managetax" element={<ManageTax />} />
          </Route>
          <Route path="accounts" element={<AccountDashboard />} />

          {/* Development */}
          <Route
            path="workspace/:workspaceId/development"
            element={<TaskPlannerDetails />}
          >
            <Route path="dashboard" element={<ProjectMgmtDashboard />} />
            <Route path="timeline" element={<DevTimeLine title="Projects" />} />
            <Route path="taskplanner" element={<IssuesListing />} />
            <Route path="calendar" element={<TaskCalendar />} />
            <Route path="epic" element={<Epic />} />
            <Route path="sprints" element={<Sprint title="Sprints" />} />
            <Route path="retrospectives" element={<Retrospectives title="Retrospectives" />} />
            <Route path="tickets" element={<Tasks title="Tickets" />} />
            <Route path="backlog" element={<BackLogs title="BackLogs" />} />
            <Route path="scrum" element={<Scrum title="Scrum" />} />
            {/* <Route
              path="release"
              element={<ReleasePlan title="Release Plan" />}
            /> */}
            <Route path="release" element={<ReleaseList />} />
            <Route path="release/:releaseId/overview"      element={<ReleaseDashboard />} />
            <Route path="release/:releaseId/pull-requests" element={<PullRequests />} />
            <Route path="release/:releaseId/qa"            element={<QATesting />} />
            <Route path="release/:releaseId/uat"           element={<UATSignoff />} />
            <Route path="release/:releaseId/gate"          element={<ReleaseGate />} />
            <Route path="release/:releaseId/release-notes" element={<ReleaseNotes />} />
            <Route path="monitoring"                      element={<MonitoringOverview />} />
            <Route path="monitoring/release-monitoring"   element={<ReleaseMonitoring />} />
            <Route path="monitoring/live-metrics"         element={<LiveMetrics />} />
            <Route path="monitoring/logs"                 element={<LogExplorer />} />
            <Route path="monitoring/alerts"               element={<Alerts />} />
            <Route path="monitoring/incidents"            element={<Incidents />} />
            <Route path="monitoring/service-health"       element={<ServiceHealth />} />
            <Route path="apiplatform"                      element={<ApiServices />} />
            <Route path="apiplatform/services"             element={<ApiServices />} />
            <Route path="apiplatform/endpoints"            element={<ApiEndpoints />} />
            <Route path="apiplatform/explorer"             element={<ApiExplorer />} />
            <Route path="apiplatform/collections"          element={<ApiCollections />} />
            <Route path="apiplatform/environments"         element={<ApiEnvironments />} />
            <Route path="apiplatform/contract-diff"        element={<ContractDiff />} />
            <Route path="apiplatform/release-tests"        element={<ReleaseTests />} />
            <Route path="apiplatform/audit-logs"           element={<AuditLogs />} />
            <Route path="components" element={<Component title="and More" />} />
            <Route path="modules" element={<Module title="and More" />} />
            <Route path="services" element={<Services title="and More" />} />
            <Route
              path="testcases"
              element={<TestCases title="Test Cases" />}
            />
            <Route path="drive" element={<WorkspaceDrive />} />
            <Route path="environment" element={<Environment title="Environment" />} />

          </Route>
          <Route path="engagements" element={<EngagementsDetails />}>
            <Route path="dashboard" element={<CalendarDashboard />} />
            <Route path="events" element={<Events />} />
            <Route path="drafts" element={<Events />} />
            <Route path="upcoming" element={<Events />} />
            <Route path="completed" element={<Events />} />
            <Route path="meetings" element={<Meetings />} />
            <Route path="contacts" element={<EggContacts />} />
          </Route>

          {/* SalesModule */}
          <Route
            path="workspace/:workspaceId/sales"
            element={<SalesModule />}
          >
            <Route path="dashboard" element={<ProjectMgmtDashboard />} />
            <Route path="sprints" element={<Sprint title="Sprints" />} />
            <Route path="tickets" element={<Tasks title="Tickets" />} />
            <Route path="backlog" element={<BackLogs title="BackLogs" />} />
            <Route path="scrum" element={<Scrum title="Scrum" />} />
            <Route
              path="release"
              element={<ReleasePlan title="Release Plan" />}
            />
            <Route path="more" element={<MoreComponents title="and More" />} />
            <Route
              path="testcases"
              element={<TestCases title="Test Cases" />}
            />
          </Route>

          {/* HrModule */}
          <Route
            path="workspace/:workspaceId/hr"
            element={<HrModule />}
          >
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="sprints" element={<Sprint title="Sprints" />} />
            <Route path="tickets" element={<Tasks title="Tickets" />} />
            <Route path="backlog" element={<BackLogs title="BackLogs" />} />
            <Route path="scrum" element={<Scrum title="Scrum" />} />
            <Route
              path="release"
              element={<ReleasePlan title="Release Plan" />}
            />
            <Route path="more" element={<MoreComponents title="and More" />} />
            <Route
              path="testcases"
              element={<TestCases title="Test Cases" />}
            />
          </Route>
          {/* FinanceModule */}
          <Route
            path="workspace/:workspaceId/finance"
            element={<FinanceModule/>}
          >
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="sprints" element={<Sprint title="Sprints" />} />
            <Route path="tickets" element={<Tasks title="Tickets" />} />
            <Route path="backlog" element={<BackLogs title="BackLogs" />} />
            <Route path="scrum" element={<Scrum title="Scrum" />} />
            <Route
              path="release"
              element={<ReleasePlan title="Release Plan" />}
            />
            <Route path="more" element={<MoreComponents title="and More" />} />
            <Route
              path="testcases"
              element={<TestCases title="Test Cases" />}
            />
          </Route>

          {/* MarketingMoudule */}
          <Route
            path="workspace/:workspaceId/marketing"
            element={<MarketingMoudule/>}
          >
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="sprints" element={<Sprint title="Sprints" />} />
            <Route path="tickets" element={<Tasks title="Tickets" />} />
            <Route path="backlog" element={<BackLogs title="BackLogs" />} />
            <Route path="scrum" element={<Scrum title="Scrum" />} />
            <Route
              path="release"
              element={<ReleasePlan title="Release Plan" />}
            />
            <Route path="more" element={<MoreComponents title="and More" />} />
            <Route
              path="testcases"
              element={<TestCases title="Test Cases" />}
            />
          </Route>

          {/* SupportMoudule */}
          <Route
            path="workspace/:workspaceId/support"
            element={<SupportModule/>}
          >
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="sprints" element={<Sprint title="Sprints" />} />
            <Route path="tickets" element={<Tasks title="Tickets" />} />
            <Route path="backlog" element={<BackLogs title="BackLogs" />} />
            <Route path="scrum" element={<Scrum title="Scrum" />} />
            <Route
              path="release"
              element={<ReleasePlan title="Release Plan" />}
            />
            <Route path="more" element={<MoreComponents title="and More" />} />
            <Route
              path="testcases"
              element={<TestCases title="Test Cases" />}
            />
          </Route>

          {/* Helpdesk */}
          <Route
            path="workspace/:workspaceId/helpdesk"
            element={<HepldeskModule />}
          >
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="sprints" element={<Sprint title="Sprints" />} />
            <Route path="tickets" element={<Tasks title="Tickets" />} />
            <Route path="backlog" element={<BackLogs title="BackLogs" />} />
            <Route path="scrum" element={<Scrum title="Scrum" />} />
            <Route
              path="release"
              element={<ReleasePlan title="Release Plan" />}
            />
            <Route path="more" element={<MoreComponents title="and More" />} />
            <Route
              path="testcases"
              element={<TestCases title="Test Cases" />}
            />
          </Route>

          {/* AssetsMoudule */}
          <Route
            path="workspace/:workspaceId/assets"
            element={<AssetsModule/>}
          >
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="sprints" element={<Sprint title="Sprints" />} />
            <Route path="tickets" element={<Tasks title="Tickets" />} />
            <Route path="backlog" element={<BackLogs title="BackLogs" />} />
            <Route path="scrum" element={<Scrum title="Scrum" />} />
            <Route
              path="release"
              element={<ReleasePlan title="Release Plan" />}
            />
            <Route path="more" element={<MoreComponents title="and More" />} />
            <Route
              path="testcases"
              element={<TestCases title="Test Cases" />}
            />
          </Route>
          
          {/* OrderModule */}
          <Route path="workspace/:workspaceId/orders" element={<OrdersPage/>} >
            <Route path="dashboard" element={<OrdersDashbord title="Dashboard" />} />
            <Route path="orders" element={<OrderOrder title="Orders" />} />
            <Route path="customers" element={<OrderCustomers title="Customers" />} />
            <Route path="products"  element={<OrderProducts title="Products" />} />
            <Route path="products/productlist" element={<OrderProductList title="ProductList"/>}/>
            <Route path="products/productcategory" element={<OrderProductCategory title="ProductCategory"/>}/>
            <Route path="products/productcategory" element={<Category title="Category"/>}/>
            <Route path="shipping" element={<OrderShipping title="Shipping" />} />
            <Route path="invoices" element={<OrderInvoices title="Invoice" />} />
            <Route path="settings" element={<OrderSettings title="Settings" />} />
          </Route>
          {/* <Route
              path="payments"
              element={<OrdersDashbord title="Payments" />}
            /> */}

          <Route path="/chat" element={<Chats />}>
            <Route path="mychats" element={<Chats />} />
            <Route path="peoples" element={<Chats />} />
            <Route path="groups" element={<Chats />} />
            <Route path="tickets" element={<Chats />} />
          </Route>

          <Route path="dms" element={<Drive />}>
            <Route path="mydrive" element={<FileDrive />} />
            <Route path="shared" element={<SharedFileDrive />} />
            <Route path="starred" element={<StarredFileDrive />} />
            <Route path="bin" element={<BinFileDrive />} />
            <Route path="recent" element={<RecentFileDrive />} />
          </Route>

          <Route path="/paybooks" element={<Invoices />}>
            <Route path="dashboard" element={<InvoiceDashboard />} />
            <Route path="invoices" element={<InvoicePage />} />
            <Route path="invoices/:folderId" element={<InvoiceList />} />
            <Route path=":folderId/view/:id" element={<PreviewInvoice />} />
            <Route
              path=":folderId/view/upload/:id"
              element={<PreviewInvoice />}
            />
            <Route path="templates" element={<InvoiceTemplate />} />
            <Route path="genrate" element={<GenrateInvoice />} />
            <Route path="payroll" element={<PayRolls />} />
            <Route path="track" element={<Track/>} />
            <Route path="estimates" element={<GenrateInvoice />} />
            <Route path="expenses" element={<GenrateInvoice />} />
            <Route path="claims" element={<GenrateInvoice />} />

            <Route path="payroll" element={<PayRolls />} >
              <Route path="dashboard" element={<PayrollDashboard />} />
              <Route path="attendance" element={<Attendance />} />
              <Route path="payruns" element={<PayRun />} />
              <Route path="payroll-history" element={<PayrollHistory />} />
              <Route path="form16" element={<Form16 />} />
              <Route path="loans" element={<Loans />} />
              <Route path="proof-of-investments" element={<ProofOfInvestments />} />
              <Route path="reimbursements" element={<Reimbursements />} />
              <Route path="salary-revision" element={<SalaryRevision />} />
            </Route>

            <Route path="purchases" element={<Purchases/>} >
              <Route path="vendors" element={<Vendors/>} />
              <Route path="expenses" element={<Expenses/>} />
              <Route path="recurringexpenses" element={<RecurringExpenses/>} />
              <Route path="purchaseorder" element={<PurchingOrder/>} />
              <Route path="bills" element={<Bills/>} />
              <Route path="recurringbills" element={<RecurringBills/>} />
            </Route>

            <Route path="sales" element={<Sales/>} >
              <Route path="estimates" element={<Estimates/>} />
              <Route path="retainerinvoices" element={<RetainerInvoices/>} />
              <Route path="salesorder" element={<SalesOrder/>} />
              <Route path="paybookinvoices" element={<PaybookInvoices/>} />
              <Route path="paymentreceived" element={<PaymentsReceived/>} />
              <Route path="recurringinvoices" element={<RecurringInvoices/>} />
            </Route>
          </Route>



          <Route path="apiclient" element={<ApiClient />}>
            <Route path="dashboard" element={<ApiClientDashboard />} />
            <Route path="environments" element={<Environments />} />
            <Route path="collections" element={<Collections />} />
            <Route path="collections/:collectionId" element={<ApiRequest />} />
            <Route path="deployment" element={<Deployment />} />
            <Route path="deployment/:id" element={<Services />} />
          </Route>

          <Route path="/org" element={<Organization />}>
            <Route path="employees" element={<Employees />} />
            <Route path="groups" element={<Groups />} />
            <Route path="departments" element={<Departments />} />
            <Route path="designations" element={<Designations />} />
            <Route path="roles" element={<Roles />} />
          </Route>

          <Route path="/admin" element={<AdminConsole />}>
            <Route path="settings" element={<Settings />} />
            <Route path="payroll" element={<Payroll />} />
            <Route path="policy" element={<PolicyDocuments />} />
            <Route path="polls" element={<Polls />} />
            <Route path="announcements" element={<Announcements />} />
            <Route path="holiday" element={<HoliDayCalendar />} />
            <Route path="changeowner" element={<Ownership />} />
            <Route path="integration" element={<Integration/>}/>
            <Route path="masterData" element={<MasterData/>}/>
          </Route>

          <Route path="customers" element={<CustomerDetails />}>
            <Route path="dashboard" element={<CustomerDashboard />} />
            <Route path="details" element={<Clients />} />
            <Route path="workflow" element={<CustomerWorkflowType />} />
            <Route path="activity" element={<CustomerActivityType />} />
            <Route path="ratings" element={<ManageRatings />} />
            <Route path="leads" element={<CustomerLeads />} />
            <Route path="settings" element={<CustomerSettings />} />
            <Route path="payments" element={<CustomerPayments />} />
            <Route path="templates" element={<MessageTemplates />} />
            <Route path="announcements" element={<CustomerAnnouncements/>} />
            <Route path="contacts" element={<EggContacts />} />
            <Route path="integration" element={<Integration/>} />
          </Route>

          <Route path="/profile/:id" element={<Profile />} />
          <Route path="/payslips" element={<Payslips />} />
          <Route
            path="*"
            element={
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "60vh",
                  textAlign: "center"
                }}
              >
                <KoIcon
                  name="PageNotFoundTwoTone"
                  width={350}
                  height={350}
                  style={{ animation: "pulse 2s infinite" }}
                />
                <KoTitle
                  text={`404`}
                  style={{
                    marginTop: "1rem",
                    fontSize: "2rem",
                    fontWeight: "bold"
                  }}
                />
                <KoTitle
                  text={`Page not found!`}
                  style={{
                    marginTop: "1rem",
                    fontSize: "1.5rem",
                    color: "#555"
                  }}
                />
                <KoButton
                  onClick={() => window.history.back()}
                  label={"Back"}
                  type={"primary"}
                  style={{ marginTop: "1rem" }}
                />
              </div>
            }
          />
        </Route>
        <Route path="open/public/feed/:feedId" element={<PublicFeed />} />
        <Route path="open" element={<Browse />}>
          <Route
            path="ticket/:accountId/:workspaceId/:ticketId"
            element={<TaskPreview />}
          />
          <Route
            path="document/:folderId/:documentId"
            element={<DocumentPerivew />}
          />
          <Route path="invoice/:id" element={<InvoicePreview />} />
          <Route
            path="calendar/:accountId/:eventId/:userId"
            element={<CalendarPreview />}
          />
          <Route path=":workspaceId/form/:formId" element={<FormCurd />} />
          <Route path=":workspaceId/form/:formId/public/:requestId" element={<PublicForm />} />
          <Route path="customer/:accountId/public/new" element={<PublicCustomer />} />
          <Route path=":accountId/b2c" element={<B2Customers />} >
            <Route path="support" element={<SuportSystem />} />
          </Route>
        </Route>

        <Route
          path="*"
          element={
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "60vh",
                textAlign: "center"
              }}
            >
              <KoIcon
                name="PageNotFoundTwoTone"
                width={350}
                height={350}
                style={{ animation: "pulse 2s infinite" }}
              />
              <KoTitle
                text={`404`}
                style={{
                  marginTop: "1rem",
                  fontSize: "2rem",
                  fontWeight: "bold"
                }}
              />
              <KoTitle
                text={`Page not found!`}
                style={{ marginTop: "1rem", fontSize: "1.5rem", color: "#555" }}
              />
              <KoButton
                onClick={() => window.history.back()}
                label={"Back"}
                type={"primary"}
                style={{ marginTop: "1rem" }}
              />
            </div>
          }
        />
      </>
    )
  );

  return <RouterProvider router={router} />;
}
export default RootRouter;
